import React from "react";
import PropTypes from "prop-types";
import MoonLoader from "react-spinners/MoonLoader";
import ClipLoader from "react-spinners/ClipLoader";
import RingLoader from "react-spinners/RingLoader";
import ScaleLoader from "react-spinners/ScaleLoader";

const LoaderType = ({ type, color }) => {
  switch (type) {
    case "Clip":
      return (
        <ClipLoader
          size={40}
          color={color}
        />
      );
    case "Ring":
      return (
        <RingLoader
          size={40}
          color={color}
        />
      );
    case "Scale":
      return (
        <ScaleLoader
          size={40}
          color={color}
        />
      );
    default:
      return (
        <MoonLoader
          size={20}
          color={color}
        />
      );
  }
};
const Loader = ({ type, color, loading, message }) => {
  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <LoaderType
            type={type}
            color={color}
          />
        </div>
      ) : (
        <div
          className="text-center"
          style={{ color: color }}
        >
          {message}
        </div>
      )}
    </>
  );
};
Loader.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  loading: PropTypes.bool,
  message: PropTypes.string,
};
Loader.defaultProps = {
  type: "",
  color: "#000000",
  loading: false,
  message: "",
};
export default Loader;
